import { render, staticRenderFns } from "./pbbsmry.vue?vue&type=template&id=44133511&scoped=true"
import script from "./pbbsmry.vue?vue&type=script&lang=js"
export * from "./pbbsmry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44133511",
  null
  
)

export default component.exports